import React from 'react';
import { LandingPage } from './pages/LandingPage';
export function App() {
  return <div className="min-h-screen w-full bg-base font-body text-ink overflow-x-hidden" data-id="element-0">
      <LandingPage data-id="element-1" />
    </div>;
}